export const textWhiteFontSemibold = "text-white font-semibold"
export const textWhieFontLight = "text-white font-light"